// Constantes partagées pour le module TURPE

export const TENSIONS = [
  { id: 'HTA', label: 'HTA (Haute Tension A)' },
  { id: 'BTSUP', label: 'BT Supérieur (> 36 kVA)' },
  { id: 'BTINF', label: 'BT Inférieur (< 36 kVA)' }
];

export const FORMULES_PAR_TENSION = {
  'HTA': ['HTACU5 PF', 'HTACU5 PM', 'HTALU5 PF', 'HTALU5 PM'],
  'BTSUP': ['BTSUPCU4', 'BTSUPLU4'],
  'BTINF': ['BTINFCU', 'BTINFCU4', 'BTINFMU4', 'BTINFMUDT', 'BTINFLU']
};

export const CONTRATS = ['CARD', 'Unique'];

export const PLAGES_PAR_FORMULE = {
  'HTACU5 PF': ['Pointe', 'HPH', 'HCH', 'HPB', 'HCB'],
  'HTACU5 PM': ['Pointe', 'HPH', 'HCH', 'HPB', 'HCB'],
  'HTALU5 PF': ['Pointe', 'HPH', 'HCH', 'HPB', 'HCB'],
  'HTALU5 PM': ['Pointe', 'HPH', 'HCH', 'HPB', 'HCB'],
  'BTSUPCU4': ['HPH', 'HCH', 'HPB', 'HCB'],
  'BTSUPLU4': ['HPH', 'HCH', 'HPB', 'HCB'],
  'BTINFCU': ['Unique'],
  'BTINFCU4': ['HPH', 'HCH', 'HPB', 'HCB'],
  'BTINFMU4': ['HPH', 'HCH', 'HPB', 'HCB'],
  'BTINFMUDT': ['HP', 'HC'],
  'BTINFLU': ['Unique']
};

// Tarifs TURPE 7 par tension (01/08/2025)
export const TARIFS_PAR_TENSION = {
  'HTA': {
    CG: { CARD: 499.80, Unique: 435.72 },
    CC: 376.39,
    CER: 2.44,
    CMDPS_ALPHA: 0.04,
    unite: 'kW'
  },
  'BTSUP': {
    CG: { CARD: 249.84, Unique: 217.80 },
    CC: 283.27,
    CER: 0,
    CMDPS_H: 12.41,
    unite: 'kVA'
  },
  'BTINF': {
    CG: { CARD: 18.00, Unique: 16.80 },
    CC: 22.00,
    CER: 0,
    CMDPS_H: 0,
    unite: 'kVA'
  }
};

// Coefficients par formule tarifaire
export const COEFFICIENTS_PAR_FORMULE = {
  'HTACU5 PF': { 
    plages: ['Pointe', 'HPH', 'HCH', 'HPB', 'HCB'],
    b: { Pointe: 14.41, HPH: 14.41, HCH: 14.41, HPB: 12.55, HCB: 11.22 },
    c: { Pointe: 0.0574, HPH: 0.0423, HCH: 0.0199, HPB: 0.0101, HCB: 0.0069 }
  },
  'HTACU5 PM': { 
    plages: ['Pointe', 'HPH', 'HCH', 'HPB', 'HCB'],
    b: { Pointe: 14.41, HPH: 14.41, HCH: 14.41, HPB: 12.55, HCB: 11.22 },
    c: { Pointe: 0.0701, HPH: 0.0405, HCH: 0.0199, HPB: 0.0101, HCB: 0.0069 }
  },
  'HTALU5 PF': { 
    plages: ['Pointe', 'HPH', 'HCH', 'HPB', 'HCB'],
    b: { Pointe: 14.41, HPH: 14.41, HCH: 14.41, HPB: 12.55, HCB: 11.22 },
    c: { Pointe: 0.0700, HPH: 0.0479, HCH: 0.0225, HPB: 0.0113, HCB: 0.0077 }
  },
  'HTALU5 PM': { 
    plages: ['Pointe', 'HPH', 'HCH', 'HPB', 'HCB'],
    b: { Pointe: 14.41, HPH: 14.41, HCH: 14.41, HPB: 12.55, HCB: 11.22 },
    c: { Pointe: 0.0847, HPH: 0.0460, HCH: 0.0225, HPB: 0.0113, HCB: 0.0077 }
  },
  'BTSUPCU4': {
    plages: ['HPH', 'HCH', 'HPB', 'HCB'],
    b: { HPH: 9.09, HCH: 6.94, HPB: 4.81, HCB: 3.56 },
    c: { HPH: 0.0533, HCH: 0.0339, HPB: 0.0150, HCB: 0.0101 }
  },
  'BTSUPLU4': {
    plages: ['HPH', 'HCH', 'HPB', 'HCB'],
    b: { HPH: 9.09, HCH: 6.94, HPB: 4.81, HCB: 3.56 },
    c: { HPH: 0.0598, HCH: 0.0383, HPB: 0.0167, HCB: 0.0113 }
  },
  'BTINFCU': {
    plages: ['Unique'],
    b: { Unique: 4.50 },
    c: { Unique: 0.0225 }
  },
  'BTINFCU4': {
    plages: ['HPH', 'HCH', 'HPB', 'HCB'],
    b: { HPH: 7.29, HCH: 5.59, HPB: 3.87, HCB: 2.89 },
    c: { HPH: 0.0471, HCH: 0.0300, HPB: 0.0133, HCB: 0.0091 }
  },
  'BTINFMU4': {
    plages: ['HPH', 'HCH', 'HPB', 'HCB'],
    b: { HPH: 7.29, HCH: 5.59, HPB: 3.87, HCB: 2.89 },
    c: { HPH: 0.0536, HCH: 0.0344, HPB: 0.0149, HCB: 0.0103 }
  },
  'BTINFMUDT': {
    plages: ['HP', 'HC'],
    b: { HP: 6.44, HC: 4.22 },
    c: { HP: 0.0406, HC: 0.0200 }
  },
  'BTINFLU': {
    plages: ['Unique'],
    b: { Unique: 4.50 },
    c: { Unique: 0.0248 }
  }
};

// 14 agences complètes
export const AGENCES_DATA = [
  { id: 'siege', nom: 'Siège' },
  { id: 'cambrai', nom: 'Cambrai Douai Sambre & Scarpe' },
  { id: 'yonne', nom: 'Yonne' },
  { id: 'somme', nom: 'Somme' },
  { id: 'belfort', nom: 'Belfort Doubs' },
  { id: 'bouches', nom: 'Bouches du rhône' },
  { id: 'cote_or', nom: "Côte d'or" },
  { id: 'pyrenees', nom: 'Pyrénées Atlantiques' },
  { id: 'haute_savoie', nom: 'Haute-Savoie' },
  { id: 'vendee', nom: 'Vendée' },
  { id: 'calvados', nom: 'Calvados Orne' },
  { id: 'cote_opale', nom: "Côte d'Opale" },
  { id: 'dunkerque', nom: 'Dunkerque - Flandres' },
  { id: 'gironde', nom: 'Gironde' }
];

// 35 commerciaux (liste identique à TICFE)
export const COMMERCIAUX_DATA = [
  { id: '1', nom: 'MUCKLISCH', prenom: 'Jérôme', email: 'j.mucklisch@placedesenergies.com', telephone: '07 45 88 95 62', agence_id: 'siege' },
  { id: '2', nom: 'OUKILI', prenom: 'Anissa', email: 'a.oukili@placedesenergies.com', telephone: '07 62 19 34 70', agence_id: 'siege' },
  { id: '3', nom: 'GARCIA', prenom: 'Bastien', email: 'b.garcia@placedesenergies.com', telephone: '07 55 53 33 47', agence_id: 'siege' },
  { id: '34', nom: 'LEDROLE', prenom: 'Tymothée', email: 't.ledrole@placedesenergies.com', telephone: '07 55 54 60 10', agence_id: 'siege' },
  { id: '8', nom: 'DUMONT', prenom: 'Nicolas', email: 'n.dumont@placedesenergies.com', telephone: '06 07 25 12 54', agence_id: 'cambrai' },
  { id: '9', nom: 'DE PONTAC', prenom: 'Matthieu', email: 'm.depontac@placedesenergies.com', telephone: '06 70 31 44 47', agence_id: 'yonne' },
  { id: '17', nom: 'LEFEBVRE', prenom: 'Ulysse', email: 'u.lefebvre@placedesenergies.com', telephone: '06 01 15 55 29', agence_id: 'somme' },
  { id: '35', nom: 'SPALLETTI', prenom: 'Adrian', email: 'a.spalletti@placedesenergies.com', telephone: '07 45 89 37 24', agence_id: 'somme' },
  { id: '10', nom: 'GOULET', prenom: 'Frédéric', email: 'f.goulet@placedesenergies.com', telephone: '06 14 58 96 74', agence_id: 'belfort' },
  { id: '11', nom: 'Henrion', prenom: 'Caroline', email: 'c.henrion@placedesenergies.com', telephone: '', agence_id: 'bouches' },
  { id: '15', nom: 'CHEVALIER', prenom: 'Christophe', email: 'c.chevalier@placedesenergies.com', telephone: '06 75 36 03 79', agence_id: 'cote_or' },
  { id: '16', nom: 'BRETHIOT', prenom: 'Sébastien', email: 's.brethiot@placedesenergies.com', telephone: '07 67 86 82 24', agence_id: 'pyrenees' },
  { id: '18', nom: 'AMEDEO', prenom: 'Jean-Baptiste', email: 'jb.amedeo@placedesenergies.com', telephone: '07 44 42 08 54', agence_id: 'haute_savoie' },
  { id: '20', nom: 'Guillet', prenom: 'Simon', email: 's.guillet@placedesenergies.com', telephone: '07 44 93 69 82', agence_id: 'vendee' },
  { id: '23', nom: 'Lesellier', prenom: 'Jérôme', email: 'j.lesellier@placedesenergies.com', telephone: '06 62 00 52 60', agence_id: 'calvados' },
  { id: '24', nom: 'Delcroix', prenom: 'Vicky', email: 'v.delcroix@placedesenergies.com', telephone: '06 84 38 69 57', agence_id: 'cote_opale' },
  { id: '25', nom: 'BOMMEL', prenom: 'Willy', email: 'w.bommel@placedesenergies.com', telephone: '06 25 33 01 56', agence_id: 'dunkerque' },
  { id: '27', nom: 'Such', prenom: 'Célia', email: 'c.such@placedesenergies.com', telephone: '07 45 88 94 02', agence_id: 'gironde' }
];
